export default __webpack_public_path__ + "static/media/sort-dsc.6996545a.svg";